import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="px-6 py-12 max-w-4xl mx-auto mt-10 lg:mt-20 shadow-lg text-baseBlue rounded-lg">
      <h1 className="text-4xl font-bold  mb-6 border-b pb-3">
        Privacy Policy
      </h1>
      <p className="mb-4 leading-relaxed">
        At <span className="font-semibold">awcgarejelebi.com</span>, we value
        your privacy and are committed to protecting your personal information.
        This Privacy Policy explains how we collect, use, and store your
        information.
      </p>

      <h2 className="text-2xl font-semibold  mt-8 mb-4">
        Information We Collect
      </h2>
      <ul className="list-disc pl-8 space-y-2">
        <li>Email address: Used for account creation and communication.</li>
        <li>Password: Used to secure your account.</li>
        <li>
          Country of residence: Used to customize content and ensure compliance
          with laws.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold  mt-8 mb-4">
        How We Use Your Information
      </h2>
      <ul className="list-disc pl-8 space-y-2">
        <li>To create and manage your account.</li>
        <li>To provide personalized services based on your location.</li>
        <li>To send important updates about our services.</li>
      </ul>

      <h2 className="text-2xl font-semibold  mt-8 mb-4">
        Data Security
      </h2>
      <p className="leading-relaxed">
        We implement robust security measures to protect your data from
        unauthorized access. Your password is encrypted, and we recommend using
        a strong password for your account.
      </p>

      <h2 className="text-2xl font-semibold  mt-8 mb-4">
        Your Rights
      </h2>
      <p className="leading-relaxed">
        You have the right to access, update, or delete your personal
        information. If you wish to exercise any of these rights, please contact
        us at <span className="text-baseGreen">awcgarejelebi@gmail.com</span>.
      </p>

      <h2 className="text-2xl font-semibold  mt-8 mb-4">
        Contact Us
      </h2>
      <p className="leading-relaxed">
        If you have any questions about this Privacy Policy, you can contact us
        at <span className="text-baseGreen">awcgarejelebi@gmail.com</span>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
